import React              from 'react';
import { useTranslation } from 'react-i18next';

import Grid       from '@mui/material/Grid';
import Spinner    from 'GeneralLayout/Spinner';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';


export default function WaitForReports(props) {

  const { t } = useTranslation();

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <Spinner/>
        </Grid>
        {props.error && !props.isValidating &&
          <Grid item>
            <Typography color="error">
              {t('serverError')}
            </Typography>
          </Grid>
        }
      </Grid>
    </>
  );
}

WaitForReports.propTypes = {
  error:        PropTypes.any,
  isValidating: PropTypes.bool,
};